module.exports = __webpack_public_path__ + "img/arrow-2.9268d6ae.svg";